import { mapState, mapActions } from 'vuex';

export default {

  computed: {
    ...mapState({
      post: (state) => state.fetcherPost.fetcherPost,
    }),
  },

  mounted() {
    // console.log('post.pid', this.$route.params.pid);

    if (this.$route.params.pid !== null) {
      this.loadFetcherPost();
    }
  },

  methods: {
    ...mapActions(['getFetcherPost']),

    async loadFetcherPost() {
      try {
        await this.getFetcherPost({
          params: {
            pid: this.$route.params.pid,
          },
        });

        // console.log('post', this.post);
        // console.log('post', this.post.tags[5].extra.current_tournament);

        // success
        // console.log('success loading post!');
      } catch (error) {
        // error
        // console.log('error loading post!');
      }
    },
  },

};
